import { StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    flexDirection: 'column',
  },
  messagesContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  errorText: {
    fontSize: 16,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  emptyText: {
    fontSize: 16,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY,
    marginTop: 12,
    textAlign: 'center',
  },
  messagesList: {
    flex: 1,
    paddingHorizontal: 16,
  },
  messagesContent: {
    paddingVertical: 16,
    paddingBottom: 20,
  },
  messageGroup: { marginBottom: 16 },
  dateHeader: { alignItems: 'center', marginVertical: 16 },
  dateText: {
    fontSize: 12,
    fontWeight: '300',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    marginVertical: 16,
  },
  messageBubble: {
    width: '65%',
    minWidth: 320,
    marginBottom: 8,
    padding: 16,
    borderRadius: 8,
  },
  senderName: {
    fontSize: 12,
    fontWeight: '500',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY,
    marginBottom: 8,
  },
  messageText: {
    fontSize: 14,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    lineHeight: 20,
  },
  messageFooter: {
    flexDirection: 'row-reverse' as const,
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 8,
  },
  timeStamp: {
    fontSize: 12,
    fontWeight: '300',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    opacity: 0.7,
  },
  senderNameBottom: {
    fontSize: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    opacity: 0.7,
  },
  fileBubbleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#1f1f1f',
    borderRadius: 8,
    padding: 8,
    marginBottom: 8,
    width: 'auto',
    maxWidth: '66%',
  },
  fileInfo: {
    flexDirection: 'column',
    marginLeft: 8,
    marginRight: 16,
  },
  fileNameText: {
    fontSize: 12,
    fontWeight: 'normal',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 2,
  },
  fileExtensionText: {
    fontSize: 12,
    fontWeight: '300',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
  },
  imageContainer: {
    marginVertical: 8,
    maxWidth: '66%',
  },
  imageBubble: {
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    padding: 4,
  },
  imagePreview: {
    width: 320,
    maxWidth: '100%',
    borderRadius: 8,
  },
  imagePlaceholder: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    width: 320,
    maxWidth: '100%',
    borderRadius: 8,
  },
  imageLabel: {
    fontSize: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    marginTop: 8,
  },
  messageInputFooter: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    borderTopWidth: 1,
    borderTopColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
  },
  fileUploadPreview: {
    paddingHorizontal: 16,
    paddingTop: 16,
    borderBottomWidth: 1,
    borderBottomColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
  },
  inputRowContainer: {
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 16,
  },
  paperclipButtonWrapper: {
    alignSelf: 'center',
  },
  paperclipButton: {
    padding: 8,
    borderRadius: 4,
  },
  messageInput: {
    flex: 1,
    fontSize: 14,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
    paddingHorizontal: 12,
    paddingVertical: 8,
    maxHeight: 120,
    minHeight: 40,
  },
  sendButtonContainer: {
    minHeight: 48,
    borderRadius: 8,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sendButtonContainerActive: {
    backgroundColor: '#4773FE',
  },
  sendButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  sendButtonText: {
    fontSize: 12,
    fontWeight: '500',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  fileUploadBubble: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#1f1f1f',
    borderRadius: 8,
    padding: 8,
    width: 'auto',
  },
  fileUploadInfo: {
    flexDirection: 'column',
    marginLeft: 8,
    marginRight: 16,
  },
  fileUploadName: {
    fontSize: 12,
    fontWeight: 'normal',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 2,
  },
  fileUploadExtension: {
    fontSize: 12,
    fontWeight: '300',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
  },
  imageUploadBubble: {
    position: 'relative',
    width: 100,
    height: 100,
  },
  imageUploadPreview: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
  imageUploadPlaceholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
  },
  deleteImageButton: {
    position: 'absolute',
    top: -4,
    right: -4,
    backgroundColor: 'rgba(0,0,0,0.7)',
    borderRadius: 12,
    padding: 4,
  },
  fileUploadDropdown: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
    overflow: 'hidden',
  },
  fileUploadDropdownHeader: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
  },
  fileUploadDropdownTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  fileUploadDropdownContent: {
    flex: 1,
    paddingBottom: 8,
    maxHeight: 520,
  },
  fileUploadSubtitle: {
    fontSize: 14,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
});

export default styles;


